import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import { EmailConfiguration } from '../models';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

@Injectable({
  providedIn: 'root'
})
export class EmailConfigurationService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  

  public postEmailConfiguration(emailConfiguration:EmailConfiguration):Observable<any> {
    return this.apiService.post(`EmailSmtpConfiguration`, emailConfiguration)
  }

  public getAllEmailConfiguration(emailConfigurationSearchParam:IGlobalSearchParam):Observable<any> {
    return this.apiService.post(`EmailSmtpConfiguration/SearchEmailConfiguration`,emailConfigurationSearchParam)
  }

  public getEmailConfigurationById(Id:number):Observable<any> {
    return this.apiService.get(`EmailSmtpConfiguration/${Id}`)
   }

  public updateEmailConfiguration(Id:number, emailConfiguration:EmailConfiguration):Observable<any> {
    return this.apiService.put(`EmailSmtpConfiguration/${Id}`, emailConfiguration)
  }

  public AddRequisitionDueExpiry():Observable<any> {
    return this.apiService.post(`Requisition/PostRequisitionDueDateNotification`,null)
  }

  public SendEmail():Observable<any> {
    return this.apiService.post(`EmailSmtpConfiguration/SendEmail`,null)
  }
}
